export default "__VITE_ASSET__0ca44fc3__"